<template>
  <tr>
    <td>
      <router-link :to="`/products/${stockRotation.product.id}`">
        {{ stockRotation.product.name }}
      </router-link>
    </td>
    <td>{{ stockRotation.product.product_category ? stockRotation.product.product_category.name : '' }}</td>
    <td class="text-right">{{ stockRotation.quantity_sold }}</td>
    <td class="text-right">{{ (stockRotation.sum_price_sold / stockRotation.quantity_sold) | priceFromCentEuro }}</td>
    <td class="text-right">{{ (stockRotation.cheapestSupplier || stockRotation.product.standard_price) | priceFromCentEuro }}</td>
    <td class="text-right">{{ getUmsatz(stockRotation)  | priceFromCentEuro }}</td>
    <td class="text-right">{{ getPreis(stockRotation)  | priceFromCentEuro }}</td>
    <td class="text-right">
      <strong>{{ getDb(stockRotation) | priceFromCentZeroEuro  }}</strong>
    </td>
  </tr>
</template>

<script>
export default {
  props: ['stockRotation', 'getDb', 'getUmsatz', 'getPreis'],
  data () {
    return {
    }
  }
}
</script>
